(() => {
  const header = document.querySelector('[data-gc-header]');
  const trigger = header?.querySelector('[data-gc-menu-toggle]');
  if (!header || !trigger) return;

  const closeMenu = () => {
    header.dataset.open = 'false';
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  };

  trigger.addEventListener('click', () => {
    const open = header.dataset.open !== 'true';
    header.dataset.open = String(open);
    trigger.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  });

  header.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  window.addEventListener('keydown', (event) => event.key === 'Escape' && closeMenu());
})();

(() => {
  const switcher = document.querySelector('[data-gc-language]');
  if (!switcher) return;

  const button = switcher.querySelector('[data-gc-language-toggle]');
  const panel = switcher.querySelector('.gc-language__list');
  const input = switcher.querySelector('input[name="locale_code"]');
  const form = switcher.querySelector('form');
  if (!button || !panel || !input || !form) return;

  const close = () => {
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  };

  const toggle = () => {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    panel.hidden = isOpen;
    button.setAttribute('aria-expanded', String(!isOpen));
  };

  button.addEventListener('click', (event) => {
    event.preventDefault();
    toggle();
  });

  switcher.querySelectorAll('[data-gc-language-option]').forEach((option) => {
    option.addEventListener('click', (event) => {
      event.preventDefault();
      input.value = option.dataset.value;
      close();
      form.submit();
    });
  });

  document.addEventListener('click', (event) => {
    if (!switcher.contains(event.target)) close();
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();
